import { opinions } from '../defaults/opinions';

export const ribeyeSteak = {
	name: 'Ribeye Steak vom Rind',
		desc: 'Mit Broccoli Romanescogemüse, Butterreis, Kräuterbutter ohne Knoblauch, Fruchtiger Mangodip, Chili Dip, Cocktailsauce und Tagesdessert',
		image: 5,
		benefits: [
			'Sehr viele Proteine',
			'Gesundes Omega3 Fett',
			'Wenig gesättigte Fettsäuren',
		],
		opinions: [
			{
				name: 'Karl Konstanz',
				date: '14. Januar 2017',
				title: 'Geil Steak',
				content: 'Endlich gibt es Steak in der Mensa. Nicht richtig Medium, aber gut für den Preis',
				rating: 3,
			},
			...opinions,
		],
		recommandation: 'Als Nachtisch villeicht etwas Müsli, das die fehlenden Ballaststoffe liefert.',
		warnings: ['rind', 'fleischAllgemein', 'sellerie', 'laktose', 'zucker'],
		ingredients: [
			{'Rindfleisch': 'rind, fleischAllgemein'},
			'Brokkoli',
			'Reis',
			'Zwiebeln',
			'Frühlingszwiebeln',
			{'Sellerie': 'sellerie'},
			{'Butter': 'laktose'},
			'Salz',
			'Pfeffer',
			'Mango',
			{'Zucker': 'zucker'},
		],
};



// WEBPACK FOOTER //
// ./src/dishes/single-dishes/ribeyeSteak.js